var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNodesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.1786C19.0703 11.1786 20.75 9.49889 20.75 7.42857C20.75 5.35826 19.0703 3.67857 17 3.67857C14.9297 3.67857 13.25 5.35826 13.25 7.42857C13.25 7.58482 13.2578 7.74107 13.2773 7.89342L9.60156 9.72935C8.92969 9.07701 8.01172 8.67857 7 8.67857C4.92969 8.67857 3.25 10.3583 3.25 12.4286C3.25 14.4989 4.92969 16.1786 7 16.1786C8.01172 16.1786 8.92969 15.7801 9.60156 15.1278L13.2773 16.9637C13.2578 17.1161 13.25 17.2684 13.25 17.4286C13.25 19.4989 14.9297 21.1786 17 21.1786C19.0703 21.1786 20.75 19.4989 20.75 17.4286C20.75 15.3583 19.0703 13.6786 17 13.6786C15.9883 13.6786 14.7031 14.6669 14.0312 15.3192L10.7227 13.6786C10.7227 14.4637 10.7227 13.6786 10.75 12.4286C10.75 12.2684 10.7422 11.3309 10.7227 11.1786L14.0312 9.72935C14.7031 10.3817 15.9883 11.1786 17 11.1786Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNodesSolid);
export default __webpack_public_path__ + "static/media/share-nodes-solid.c961eb6ef67d8e2ff7828138d5d415b7.svg";
export { ForwardRef as ReactComponent };